export default __webpack_public_path__ + "static/media/Prancheta AC 1-2.16085280.svg";